import { render, staticRenderFns } from "./list.vue?vue&type=template&id=28640ac3&scoped=true&"
import script from "./list.vue?vue&type=script&lang=js&"
export * from "./list.vue?vue&type=script&lang=js&"
import style0 from "./list.vue?vue&type=style&index=0&id=28640ac3&lang=less&scoped=true&"
import style1 from "./list.vue?vue&type=style&index=1&id=28640ac3&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28640ac3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28640ac3')) {
      api.createRecord('28640ac3', component.options)
    } else {
      api.reload('28640ac3', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=28640ac3&scoped=true&", function () {
      api.rerender('28640ac3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/shop/list.vue"
export default component.exports